import React from "react";
import "./Visit.css";
import map from "../img/visit images/Zoo Map.svg";
import iconImg from "../img/visit images/plan your visit icons.png";
import warning from "../img/visit images/plan your visit warning icons.png";

export default function Visit() {
  
  return (
    <section className="visit" id="planeYourVisit" >
      <h1 className="heading">Visit plan</h1>
      <div className="flex">
        <div className="col1">
          <img src={map} alt="map" className="map" />
          <div className="content">
            <h2 className="content-heading">Zoo Timings</h2>
            <p>
              The operational timings of the zoo are from 09:00 am till sunset
              and the zoo is open round the week.
            </p>
            <div className="col-wrapper">
              <div className="col">
                <h2>Ticket Rates</h2>
                <ul>
                  <li>Adult: PKR 40</li>
                  <li>Child: PKR 20</li>
                </ul>
              </div>
              <div className="col">
                <h2>Student Package</h2>
                <ul>
                  <li>Upto 50: PKR 600</li>
                  <li>Upto 100: PKR 1000</li>
                </ul>
              </div>
            </div>
            <div className="note">
              <h2>Note</h2>
              <ul>
                <li>Tickets are applicable for the same date of purchase.</li>
                <li>Tickets are non-refundable and non-transferable.</li>
                <li>
                  School, Colleges, University and other educational
                  institutions shall come up with a request on letterhead of
                  their institution, so they can be considered for student
                  package.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col2">
          <img src={iconImg} alt="icon" className="iconImg" />
          <img src={warning} alt="waring" className="warn" />
        </div>
      </div>
    </section>
  );
}
